import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import ArrowUp from '../../../assets/images/rn/ArrayUp';
import ArrowDown from '../../../assets/images/rn/ArrayDown';
import { RichText } from '../../RichText/rn';
import { FONT_WEIGHT_BOLD, FONT_WEIGHT_REGULAR } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useTracking } from '../../../hooks/rn/useTracking';
var AccordionItem = function AccordionItem(props) {
  var title = props.title,
    content = props.content,
    expand = props.expand;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var Icon = expand ? selected ? ArrowUp : ArrowDown : null;
  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var onClick = function onClick() {
    if (!expand) {
      return;
    }
    trackingClick && tracker.click(trackingClick);
    setSelected(!selected);
  };
  return /*#__PURE__*/React.createElement(View, trackingImpressionProps, /*#__PURE__*/React.createElement(Pressable, {
    onPress: onClick
  }, /*#__PURE__*/React.createElement(View, {
    style: styles['accordion-item-title-container']
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles['accordion-item-title'], selected && styles['title-select']]
  }, title), Icon && /*#__PURE__*/React.createElement(Icon, null))), selected && /*#__PURE__*/React.createElement(RichText, {
    className: "accordion-item-content",
    classNameStyles: {
      'accordion-item-content': styles['accordion-item-content']
    },
    content: content
  }));
};
export var Accordion = function Accordion(props) {
  var accordionList = props.accordionList,
    _props$expand = props.expand,
    expand = _props$expand === void 0 ? true : _props$expand;
  return /*#__PURE__*/React.createElement(View, {
    style: styles['accordion-container']
  }, accordionList.map(function (item, index) {
    var trackingData = props.trackingData ? _objectSpread(_objectSpread({}, props.trackingData), {}, {
      trackingdataBasic: _objectSpread(_objectSpread({}, props.trackingData.trackingdataBasic || {}), {}, {
        content: item.title,
        location: index
      })
    }) : undefined;
    return /*#__PURE__*/React.createElement(AccordionItem, {
      key: item.content + item.title + index,
      title: item.title,
      content: item.content,
      trackingData: trackingData,
      expand: expand
    });
  }));
};
var styles = CustomStyleSheet({
  // .@{prefix-cls}-accordion-container {
  //   border: 1px solid rgba(0, 0, 0, 0.09);
  //   border-left: none;
  //   border-right: none;
  'accordion-container': {
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderWidth: 1,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    marginVertical: 8
  },
  // .title {
  //   color: rgba(0, 0, 0, 0.87);
  //   margin: -1px 0px;
  //   background: #ffffff;
  //   border: 1px solid rgba(0, 0, 0, 0.09);
  //   font-weight: 700;
  //   font-size: 14px;
  //   line-height: 22px;
  //   padding: 8px 12px;
  //   position: relative;
  //   display: flex;
  //   justify-content: space-between;
  // }
  'accordion-item-title-container': {
    marginVertical: -1,
    marginHorizontal: 0,
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#e6e8ed',
    paddingVertical: 8,
    paddingHorizontal: 12,
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  'accordion-item-title': _objectSpread(_objectSpread({
    color: 'rgba(0, 0, 0, 0.87)'
  }, FONT_WEIGHT_BOLD), {}, {
    fontSize: 14,
    lineHeight: 22,
    maxWidth: '90%'
  }),
  // .accordion-item-content {
  //   background: #ffffff;
  //   border: 1px solid rgba(0, 0, 0, 0.09);
  //   color: rgba(0, 0, 0, 0.87);
  //   font-weight: 400;
  //   font-size: 14px;
  //   line-height: 20px;
  //   padding: 8px 12px;
  //   margin: -1px 0px;
  // }
  'accordion-item-content': _objectSpread(_objectSpread({
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#e6e8ed',
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginVertical: -1,
    marginHorizontal: 0
  }, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 20,
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  // .title.selected {
  //   font-weight: 700;
  //   color: #ee4d2d;
  // }
  'title-select': _objectSpread(_objectSpread({}, FONT_WEIGHT_BOLD), {}, {
    color: '#ee4d2d'
  })
});